import 'core-js/es/promise/finally';
import 'core-js/features/url-search-params';
import 'core-js/features/string';

import 'select2';
import './vendor/bootstrap';
import './components/init-global-vue';
import './components/init-components';
import './components/market/_init-components-market';
import './components/init-directives';
import './components/init-filters';
import { initVueApps } from './modules/vue-global-initializer';
import { checkRedirect, sendBill, checkLabRedirect } from './modules/main';
import { initMaskFields } from './modules/mask';
import { initTabsScrollsar } from './modules/scrollbar/tabs-nav-scrollbar';
import { initProfileNav } from './modules/profile-nav';
import { initHeaderHints } from './modules/header-hints';
import { BasketService } from './services/basket-service';
import { FavoritesService } from './services/favorites-service';
import { initCustomSelect } from './modules/custom-select';
import { initMenuPanel } from './modules/menu-panel';
import { initAdaptiveSticky } from './modules/adaptive-sticky';
import { UserGeoService } from './services/user-geo-service';
import { initRecommendSlider } from './modules/sliders/recommend-slider';
import { initYouWatchedSlider } from './modules/sliders/you-watched-slider';
import { initReviewsSlider } from './modules/sliders/reviews-slider';
import { initGlitchRandom } from './modules/glitch-random';
import { initViewBtns } from './modules/view-btns';
import { initCatalogFilter } from './modules/catalog-filter';
import { initLazyLoad } from './modules/lazyload';
import { initTabsSlider } from './modules/sliders/tabs-slider';
import { initTabsSliderMain } from './modules/sliders/tabs-slider-main';

if (window.specialtyApp) {
    window.specialtyApp.basketService = new BasketService();
    window.specialtyApp.favoritesService = new FavoritesService();
    window.specialtyApp.userGeoService = UserGeoService;
} else {
    window.specialtyApp = {
        basketService: new BasketService(),
        favoritesService: new FavoritesService(),
        userGeoService: UserGeoService,
    };
}

document.addEventListener('DOMContentLoaded', () => {
    initVueApps();
    checkRedirect();
    sendBill();
    checkLabRedirect();
    initMaskFields();
    initTabsScrollsar();
    initProfileNav();
    initHeaderHints();
    initCustomSelect();
    initMenuPanel();
    initAdaptiveSticky();
    initGlitchRandom();
    initRecommendSlider();
    initYouWatchedSlider();
    initReviewsSlider();
    initViewBtns();
    initLazyLoad();
    initTabsSlider();
    initTabsSliderMain();
    initCatalogFilter();


    //По какой-то неведомой причине модалка не открывалась на странице оформления заказа
    //Надо в будущем выяснить причины
    $('body').on('click', '[data-target="#regionModal"]', (event) => {
        event.preventDefault();
        $('#regionModal').modal('show');
    });

    $('.filter-sort__mobile-open').click(function() {
        $('.filter-sort__mobile-fade').fadeIn();
        return false;
    });


    $('.filter-dropdown').click(function(){
        $(this).toggleClass('filter-dropdown--open');
        $(this).toggleClass('filter-dropdown--open');
        $(this).find('.filter-dropdown__options').css("display", "block");
    })
    function closeMenuPanel(){
        $('.filter-sort__mobile-fade').fadeOut();
        return false;
    }

    $('body').on('click', '#set_filter, .filter-sort__mobile-close', closeMenuPanel);

});
